/**
 * GA4 Route Detection - Identifies page type from URL
 * No Liquid dependency. Used by ga4-tracker.js to load the right handler.
 */

(function () {
  const ROUTES = {
    PRODUCT: 'product',
    COLLECTION: 'collection',
    SEARCH: 'search',
    INDEX: 'index',
    BRANDS: 'brands',
    CART: 'cart',
    PAGE: 'page',
  };

  /**
   * @param {string} [pathname] - window.location.pathname
   * @returns {{ type: string, handle?: string, pageType: string }}
   */
  function getRoute(pathname) {
    const path = (pathname || window.location.pathname || '').replace(/^\//, '').replace(/\/$/, '');
    const segments = path ? path.split('/') : [];

    if (segments[0] === 'products' && segments[1]) {
      return { type: ROUTES.PRODUCT, handle: segments[1], pageType: 'product' };
    }
    if (segments[0] === 'collections' && segments[1]) {
      return { type: ROUTES.COLLECTION, handle: segments[1], pageType: 'collection' };
    }
    if (segments[0] === 'search') {
      return { type: ROUTES.SEARCH, pageType: 'search' };
    }
    if (segments[0] === 'cart') {
      return { type: ROUTES.CART, pageType: 'cart' };
    }
    if (segments[0] === 'pages' && segments[1]) {
      const handle = segments[1].toLowerCase();
      if (handle === 'brands' || handle === 'brand') {
        return { type: ROUTES.BRANDS, handle: segments[1], pageType: 'brands' };
      }
      return { type: ROUTES.PAGE, handle: segments[1], pageType: 'page' };
    }
    if (path === '' || path === 'index' || segments[0] === '') {
      return { type: ROUTES.INDEX, pageType: 'index' };
    }
    if (segments[0] === 'blogs' && segments[1]) {
      return { type: ROUTES.PAGE, handle: segments[1], pageType: 'blog' };
    }
    if (segments[0] === 'articles' && segments[1]) {
      return { type: ROUTES.PAGE, handle: segments[1], pageType: 'article' };
    }

    return { type: ROUTES.PAGE, pageType: 'page' };
  }

  window.trovelle = window.trovelle || {};
  window.trovelle.ga4 = window.trovelle.ga4 || {};
  window.trovelle.ga4.route = { getRoute };
})();
